export default {
  documentation: "Documentation",
  brandKit: "Brand Kit",
  legalDisclaimer: "Legal Disclaimer",
}
